import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 301  -  天气
 */

export default class EventWeather extends EventBase {
  /**
   * 构造函数
   */
  constructor() {
    super()
    this.Parameter = ['0', '']
  }

  // #region 事件内关键属性参数
  /**
   * 天气Index(0:无天气效果 1:刮风 2:下雨 3:下雪)
   */
  get WeatherIndex() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set WeatherIndex(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  /**
   * 描述信息
   */
  get Description() {
    return this.Parameter?.[1] ?? ''
  }
  set Description(value) {
    this.Parameter && (this.Parameter[1] = value.toString())
  }

  // #endregion

  /**
   * 事件ID
   */
  Code = EventID.Weather

  /**
   * 获得该事件在事件列表的描述信息
   */
}
